(function () {
  function syncQuantityBadge(box) {
    box.querySelectorAll('.moonbundle-option-quantity').forEach((badge) => {
      const optionEl = badge.closest('.moonbundle-option');
      const titleEl = optionEl ? optionEl.querySelector('.moonbundle-option-title') : null;
      if (titleEl && /FRATRIE/i.test(titleEl.textContent) && badge.textContent.trim() === 'x1') {
        badge.textContent = 'x2';
      }
    });
  }

  function syncPrice(box) {
    const active = box.querySelector('.moonbundle-option.moonbundle-option-active') || box.querySelector('.moonbundle-option');
    if (!active) return;

    const currentPriceEl = active.querySelector('.moonbundle-option-single-price');
    const oldPriceEl = active.querySelector('.moonbundle-option-old-price');
    if (!currentPriceEl) return;

    const priceBlock = document.querySelector('[id^="price-"]');
    if (!priceBlock) return;

    const saleEl = priceBlock.querySelector('.price__sale .price-item--sale');
    const wasEl = priceBlock.querySelector('.price__sale s.price-item--regular');

    const currentPriceText = currentPriceEl.textContent.trim();
    if (saleEl && saleEl.textContent.trim() !== currentPriceText + ' EUR') {
      saleEl.textContent = currentPriceText + ' EUR';
    }

    if (oldPriceEl && wasEl) {
      const oldPriceText = oldPriceEl.textContent.trim();
      if (oldPriceText && wasEl.textContent.trim() !== oldPriceText + ' EUR') {
        wasEl.textContent = oldPriceText + ' EUR';
      }
    }
  }

  function sync(box) {
    syncQuantityBadge(box);
    syncPrice(box);
  }

  function watch(box) {
    sync(box);
    let debounceId;
    const observer = new MutationObserver(() => {
      window.clearTimeout(debounceId);
      debounceId = window.setTimeout(() => sync(box), 30);
    });
    observer.observe(box, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  const existingBox = document.querySelector('.moonbundle-box');
  if (existingBox) {
    watch(existingBox);
    return;
  }

  let attempts = 0;
  const retry = window.setInterval(() => {
    attempts += 1;
    const box = document.querySelector('.moonbundle-box');
    if (box) {
      window.clearInterval(retry);
      watch(box);
    } else if (attempts > 40) {
      window.clearInterval(retry);
    }
  }, 250);
})();
